import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { EForm } from '../../../shared-components/e-forms/e-form.model';
import { EFormService } from '../../../shared-components/e-forms/e-form.service';
import * as _ from 'lodash';
import { LoginService } from '../../../shared-modules/login/login.service';


@AutoUnsubscribe({ includeArrays: true })
@Component({
    selector: 'app-e-form-unfinished-dialog',
    templateUrl: './e-form-unfinished-dialog.component.html'//,
    //styleUrls: ['./e-form-unfinished-dialog.component.css']
})
export class EFormUnfinishedDialogComponent implements OnInit, OnDestroy {

    selectedForm: EForm;
    lastUpdatedOn: Date;
    lastUpdatedBy: string;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private eFormService: EFormService,
        private loginService : LoginService,
        private dialogRef: MatDialogRef<EFormUnfinishedDialogComponent>
    ) {
        this.selectedForm = _.cloneDeep(data.Form);
    }

    ngOnInit() {
        if(this.selectedForm.LastUpdatedOn) {
            this.lastUpdatedOn = this.selectedForm.LastUpdatedOn;            
            this.lastUpdatedBy = this.selectedForm.LastUpdatedByName;
        }
        else {
            this.lastUpdatedOn = this.selectedForm.CreatedOn;
            this.lastUpdatedBy = this.selectedForm.CreatedByName;
        }
        // if(!this.lastUpdatedBy && !this.loginService.LoginSettings.V10){
        //     this.lastUpdatedBy = this.selectedForm.SubmittedName;
        // }
    }

    continue() {
        this.dialogRef.close('Continue');
    }

    startOver() {
        this.dialogRef.close('StartOver');
    }

    ngOnDestroy() { }


    cancelClick() {
        this.dialogRef.close();
    }
}
